export function isValidLocaleSegment(locale: string | undefined): locale is string {
  if (!locale) {
    return false;
  }

  // Expected route locale formats: en-US, fr-FR, pt-BR, zh-Hans, zh-Hant
  // Accept any casing; consumers can normalize as needed.
  return /^([a-z]{2})-([a-z]{2}|[a-z]{4})$/i.test(locale);
}

export function normalizeLocaleForTranslations(locale: string | undefined): string | undefined {
  if (!locale) {
    return undefined;
  }

  const normalized = locale.toLowerCase();

  // Common alias: "jp" is not a valid language code; treat it as Japanese.
  if (normalized === "jp-jp") {
    return "ja-jp";
  }

  return normalized;
}

export function normalizeLocaleForCulture(locale: string | undefined): string | undefined {
  const normalized = normalizeLocaleForTranslations(locale);
  if (!normalized) {
    return undefined;
  }

  const match = normalized.match(/^([a-z]{2})-([a-z]{2}|[a-z]{4})$/);
  if (!match) {
    return undefined;
  }

  const language = match[1];
  const regionOrScript = match[2];

  // Region: ja-JP
  if (regionOrScript.length === 2) {
    return `${language}-${regionOrScript.toUpperCase()}`;
  }

  // Script: zh-Hans
  return `${language}-${regionOrScript[0].toUpperCase()}${regionOrScript.slice(1)}`;
}
